/**
 * - Removed `ItemWrap` from first slot
 * - Changed grid `md` to `lg`
 */

import { LayoutSlot } from '@/components/layouts/LayoutSlot';
import {
	getAsideContainerSx,
	getSectionContainerSx,
	layoutMainSX,
	mainContainerSx,
	stickySidebarSx,
	widgetContainerSx,
} from '@/components/layouts/styles/main';
import { Layout } from '@/data/types/Layout';
import { Container, Grid, Stack } from '@mui/material';
import { FC, useMemo } from 'react';

const PLP_ASIDE_WIDGETS = ['FacetNavigation'];
const WISHLIST_ASIDE_WIDGET = 'WishList Display View';
const PLP_BREAKPOINT = 960;
const DEFAULT_BREAKPOINT = 1200;

export const Aside: FC<{ layout: Layout }> = ({ layout }) => {
	const breakpoint = useMemo(
		() =>
			layout.slots.aside?.some((widget) => PLP_ASIDE_WIDGETS.includes(widget.name))
				? PLP_BREAKPOINT
				: DEFAULT_BREAKPOINT,
		[layout.slots.aside]
	);

	const isAccountPage = useMemo(
		() => layout.slots.aside?.[0].id === 'account-sidebar',
		[layout.slots.aside]
	);
	const isWishListDetailPage = useMemo(
		() => layout.slots.aside?.[0].id === WISHLIST_ASIDE_WIDGET,
		[layout.slots.aside]
	);

	const asideSx = useMemo(
		() => getAsideContainerSx(breakpoint, isAccountPage),
		[breakpoint, isAccountPage]
	);
	const sectionSx = useMemo(
		() => getSectionContainerSx(breakpoint, isAccountPage),
		[breakpoint, isAccountPage]
	);
	if (!layout) return null;

	return (
		<>
			<LayoutSlot slot={layout.slots.header} />

			<Stack component="main" sx={layoutMainSX(layout.slots.first?.length || 0)}>
				<LayoutSlot slot={layout.slots.first} widgetContainerSx={widgetContainerSx} />

				<Container component="section" sx={mainContainerSx}>
					<Grid container>
						<Grid item component="aside" aria-label={layout.slots.aside?.at(0)?.name} sx={asideSx}>
							<Stack gap={1.25} sx={isWishListDetailPage ? stickySidebarSx : {}}>
								<LayoutSlot slot={layout.slots.aside} />
							</Stack>
						</Grid>

						<Grid item component="section" sx={sectionSx}>
							<Stack gap={1.25}>
								<LayoutSlot slot={layout.slots.second} />
							</Stack>
						</Grid>
					</Grid>
				</Container>

				<LayoutSlot slot={layout.slots.footer} />
			</Stack>
		</>
	);
};
